import { useEffect } from 'react'
import { Box, Divider, Button, Grid } from '@mui/material'
import EventCreateModal from '../Components/Events/ManageEvents/EventActions/EventCreateModal'
import EventFilter from '../Components/Events/EventFilter'
import EventTable from '../Components/Events/ManageEvents/EventTable'
import { backgroundColors } from '../Components/Common/Color/Color'
import RefreshIcon from '@mui/icons-material/Refresh'
import { useAppDispatch, useAppSelector } from '../redux/store'
import SearchInput from '../Components/Common/SearchInput'
import { fetchEvents } from '../redux/event/manageEvents/actions'
import { setSearchQuery } from '../redux/event/manageEvents/slice'
import { selectSearchQuery } from '../redux/event/manageEvents/selector'
import { selectUserTeamMemberInfo } from '../redux/auth/selector'

// Main Component
const ManageEventPage = () => {
  const teamMemberDetails = useAppSelector(selectUserTeamMemberInfo)

  const dispatch = useAppDispatch()
  const searchQuery = useAppSelector(selectSearchQuery)

  const fetchData = async () => {
    await dispatch(fetchEvents()).unwrap()
  }

  useEffect(() => {
    fetchData()
  }, [dispatch])

  const handleRefreshData = async () => {
    await fetchData()
  }

  const handleSearchChange = (query: string) => {
    dispatch(setSearchQuery(query))
  }

  const handleClearSearch = () => {
    dispatch(setSearchQuery(''))
  }

  return (
    <Box
      component='div'
      sx={{ p: 0, backgroundColor: backgroundColors.white, width: 'auto' }}
      borderRadius={2}
      boxShadow={1}
    >
      <Grid
        container
        sx={{ p: 2 }}
        flexDirection='row'
        alignItems={'center'}
        justifyContent='space-between'
      >
        <Grid>
          <EventCreateModal />
        </Grid>
        <Grid>
          <Grid container spacing={2} alignItems='center' display='flex'>
            <Grid>
              <Button
                id='refresh-button'
                color='success'
                startIcon={<RefreshIcon />}
                onClick={handleRefreshData}
                size='small'
              >
                Refresh
              </Button>
            </Grid>

            <Grid>
              <EventFilter />
            </Grid>
            <Grid>
              <SearchInput
                searchQuery={searchQuery}
                onSearchChange={handleSearchChange}
                onClearSearch={handleClearSearch}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box>
        <Divider />
        <EventTable teamMemberDetails={teamMemberDetails} />
      </Box>
    </Box>
  )
}

export default ManageEventPage
